<ion-content [fullscreen]="true" [scroll-y]="false" class="ion-padding">
  <div class="p-container">
    <div class="p-block">
      <h2><strong>Premium Version</strong></h2>
    </div>

    <div class="p-block">
      <strong>{{ 'PREM_DESC' | translate }}</strong>
    </div>

    <div class="p-block list">
      <ul>
        <li>{{ 'PREM_LI_1' | translate }}</li>
        <li>{{ 'PREM_LI_2' | translate }}</li>
        <li>{{ 'PREM_LI_3' | translate }}</li>
      </ul>
    </div>

    <div class="p-block">
      <h2>29 Euro / {{ 'PREM_YEAR' | translate }}</h2>
    </div>

    <div class="p-block">
      <ion-button expand="block" (click)="dismiss(true)">
        <strong>{{ 'PREM_BUTTON' | translate }}</strong>
      </ion-button>
    </div>
  </div>

  <!-- Floating Action Button -->
  <ion-fab slot="fixed" vertical="top" horizontal="start" class="custom-fab">
    <ion-fab-button size="small" (click)="dismiss(false)">
      <ion-icon name="close"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ion-content>
